import React, { useState } from "react";
import { Container, Row, Col, Card, Input } from "reactstrap";

function ProductListingPricing(props) {

  const [pricing, setPricing] = useState({
    currency: "INR",
    mrp: "",
    salePrice: "",
    minPrice: "",
    maxPrice: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setPricing({
      ...pricing,
      [name]: value
    });
  };

  return (

    <Container>

      <Row>

        {/* Page Title */}

        <Col md={12} className="mt-4 mb-3">
          <h4>Step 7 : Pricing</h4>
        </Col>


        {/* Pricing Card */}

        <Col md={12}>

          <Card className="p-4">

            <Row className="mb-3">
              <Col md={4}><b>Currency</b></Col>
              <Col md={8}>
                <Input
                  type="select"
                  name="currency"
                  value={pricing.currency}
                  onChange={handleChange}
                >
                  <option value="INR">INR</option>
                  <option value="USD">USD</option>
                  <option value="AED">AED</option>
                </Input>
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4}><b>MRP</b></Col>
              <Col md={8}>
                <Input
                  type="number"
                  name="mrp"
                  value={pricing.mrp}
                  onChange={handleChange}
                  placeholder="Enter MRP"
                />
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4}><b>Sale Price</b></Col>
              <Col md={8}>
                <Input
                  type="number"
                  name="salePrice"
                  value={pricing.salePrice}
                  onChange={handleChange}
                  placeholder="Enter Sale Price"
                />
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4}><b>Minimum Price</b></Col>
              <Col md={8}>
                <Input
                  type="number"
                  name="minPrice"
                  value={pricing.minPrice}
                  onChange={handleChange}
                  placeholder="Enter Minimum Price"
                />
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4}><b>Maximum Price</b></Col>
              <Col md={8}>
                <Input
                  type="number"
                  name="maxPrice"
                  value={pricing.maxPrice}
                  onChange={handleChange}
                  placeholder="Enter Maximum Price"
                />
              </Col>
            </Row>

          </Card>

        </Col>


        {/* Navigation Buttons */}

        <Col md={12} className="mt-3 d-flex justify-content-between">

          <button
            className="btn btn-light"
            onClick={props.prevStep}
          >
            ← Back
          </button>

          <button
            className="btn btn-primary"
            onClick={props.nextStep}
          >
            Next →
          </button>

        </Col>

      </Row>

    </Container>

  );
}

export default ProductListingPricing;